import mdhtml from '../content/text1.md';
import { classDates, moduleEvents, problemSetsAssignedEvents, problemSetsDueEvents, breakDayEvents, dialogueEvents, examEvents, cancelledEvents } from '../content/calendarinfo'
import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';


document.querySelector(".bodytext").innerHTML = mdhtml;

const monthNames = ["January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];

const formatDate = x => {
    const date = new Date(x+'T00:00:00');
    const day = date.getDate();
    const month = monthNames[date.getMonth()];
    return month.slice(0,3)+" "+day;
}

console.log(cancelledEvents)
console.log(dialogueEvents)

const moduleStartDates = moduleEvents.filter(x=>x.firstinmodule)

const readingsTableLines = moduleEvents.reduce((acc, curr, i) => (acc+`
            <tr class="${i%2!==0 ? "pure-table-odd" : ""}">
                <td id="reading-${curr.start}">${formatDate(curr.start)}</td>
                <td>${curr.firstinmodule ? curr.title : ""}
                </td>
                <td><ul>${curr.readings.map(x=>`<li>${x}</li>`).join('')}</ul></td>
            </tr>`
            ), "")


document.querySelector(".readings").innerHTML = `
    <thead>
        <tr>
            <th>Date</th>
            <th>Module</th>
            <th style="min-width:600px">Readings</th>
        </tr>
    </thead>
    <tbody>
        ${readingsTableLines}
    </tbody>
`



const calendarEl = document.getElementById('calendar');

const calendar = new Calendar(calendarEl, {
	    plugins: [ dayGridPlugin, interactionPlugin],
		eventSources: [{events: moduleEvents, display: 'background', backgroundColor: "#e6e6e6"},
						{events: problemSetsAssignedEvents, display: 'list-item', color: "#00bdbd", textColor: "#00bdbd"},
                        {events: problemSetsDueEvents, display: 'list-item', color: "#00bdbd", textColor: "#00bdbd"},
						{events: breakDayEvents, display: 'background', backgroundColor: 'lightblue'},
                        {events: dialogueEvents, display: 'list-item', color: "#00bdbd", textColor: "#00bdbd"},
						{events: examEvents, display: 'background', backgroundColor: 'lightpink'},
                        {events: cancelledEvents, display: 'background', backgroundColor: 'lightpink'}
						],
        dateClick: function(info) {
            const clickedDate = info.dateStr.slice(0,10);
            if (classDates.includes(clickedDate)) {
                document.getElementById("reading-"+clickedDate).scrollIntoView();
            }
        }
});

calendar.render();

var styleEl = document.createElement('style'), styleSheet;
            document.head.appendChild(styleEl);
            styleSheet = styleEl.sheet;
            styleSheet.insertRule(".fc-daygrid-dot-event {white-space: normal; color: #00bdbd}", 0);
            styleSheet.insertRule(".fc .fc-bg-event {opacity: 0.5}", 0);
            styleSheet.insertRule(".fc-event-time {opacity: 0}", 0);

            


